import { Square } from '../../../../shared/components/utility/square/Square'
import { BpCard } from '../../../../shared/components/cards/card/BpCard'
import { BpButton } from '../../../../shared/components/buttons/bp-button/BpButton'
import {
  useGetComplianceGetEmailListQuery,
  useLazyGetSiteGoogleReportOauthUrlQuery,
  usePostSiteGoogleReportOauthDeleteTokenMutation,
} from '../../../../app/api'
import { IconButton } from '../../../../shared/components/buttons/icon-button/IconButton'
import { IconTrash } from '../../../../shared/components/icons/IconTrash'
import { Tooltip } from 'antd'
import { useLocation } from 'react-router-dom'
import { useAppSelector } from '../../../../app/store/hooks/Redux'
import { IUserModel } from '../../../../app/store/models/User.model'
import { selectUser } from '../../../../app/store/reducers/AuthSlice'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import styles from './LinkedEmails.module.scss'

export const LinkedEmails = ({ className }: { className?: string }) => {
  const { t } = useTranslation()
  const location = useLocation()
  const { allow_sending_from_linked_emails } = useAppSelector<IUserModel>(selectUser)

  const { data, refetch } = useGetComplianceGetEmailListQuery()

  const [getGoogleReportOauthUrl] = useLazyGetSiteGoogleReportOauthUrlQuery()
  const [oauthDeleteToken] = usePostSiteGoogleReportOauthDeleteTokenMutation()

  if (!allow_sending_from_linked_emails) {
    return null
  }

  return (
    <Square className={className}>
      <BpCard
        footer={
          <BpButton
            className={clsx(styles.button)}
            onClick={() =>
              getGoogleReportOauthUrl()
                .unwrap()
                .then((response) => {
                  if (!response.data?.auth_url) return

                  localStorage.setItem('last-path', location.pathname + location.search)
                  window.location.href = response.data.auth_url
                })
                .catch(() => undefined)
            }
          >
            {t('buttons.add')}
          </BpButton>
        }
        description={t('pages.profile.gmailDescription')}
        title={t('pages.profile.linkedGmail')}
      >
        <div className={clsx(styles.list)}>
          {data?.data?.map((email, index) => (
            <div key={index} className={clsx(styles.row)}>
              <Tooltip title={email}>
                <div className={clsx(styles.emailText)}>{email}</div>
              </Tooltip>
              <IconButton
                disabled={email === 'compliance.manager@bluepear.co'}
                size='lg'
                onClick={() =>
                  oauthDeleteToken({ body: { email } }).then(() => {
                    refetch()
                  })
                }
              >
                <IconTrash color='#00326D' />
              </IconButton>
            </div>
          ))}
        </div>
      </BpCard>
    </Square>
  )
}
